'use client';

// Server-renders <style jsx> blocks into the initial HTML (App Router needs
// this registry wired explicitly). Without it, styled-jsx styles only apply
// after client hydration, so every hard load flashes unstyled content —
// e.g. the projects logo at natural SVG size instead of 24px.
// Pattern from the Next.js docs: app/registry with useServerInsertedHTML.
import { useState, type ReactNode } from 'react';
import { useServerInsertedHTML } from 'next/navigation';
import { StyleRegistry, createStyleRegistry } from 'styled-jsx';

export default function StyledJsxRegistry({ children }: { children: ReactNode }) {
  const [registry] = useState(() => createStyleRegistry());

  useServerInsertedHTML(() => {
    const styles = registry.styles();
    registry.flush();
    return <>{styles}</>;
  });

  return <StyleRegistry registry={registry}>{children}</StyleRegistry>;
}
